const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCovid19(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M28.572,13.293h-0.549 c-0.26,0-0.473,0.211-0.473,0.471v1.094h-2.145c-0.215-1.763-0.916-3.375-1.965-4.699l1.527-1.526l0.781,0.78 c0.184,0.185,0.48,0.185,0.664,0l0.389-0.388c0.186-0.185,0.186-0.482,0-0.666l-3.162-3.162c-0.184-0.184-0.48-0.184-0.666,0 l-0.387,0.388c-0.184,0.185-0.184,0.482,0,0.666l0.754,0.754l-1.537,1.537c-1.338-1.031-2.957-1.713-4.725-1.905V4.448h1.156 c0.26,0,0.471-0.212,0.471-0.471v-0.55c0-0.26-0.211-0.471-0.471-0.471h-4.472c-0.26,0-0.471,0.211-0.471,0.471v0.55 c0,0.259,0.211,0.471,0.471,0.471h1.015v2.216c-1.697,0.229-3.25,0.907-4.536,1.913L8.665,6.998L9.413,6.25 c0.184-0.184,0.184-0.481,0-0.666L9.024,5.196c-0.184-0.184-0.482-0.184-0.666,0L5.196,8.358c-0.184,0.184-0.184,0.481,0,0.666 l0.388,0.388c0.184,0.185,0.482,0.185,0.666,0l0.787-0.786l1.579,1.578c-1.029,1.315-1.715,2.911-1.927,4.653H4.448v-1.094 c0-0.26-0.211-0.471-0.471-0.471H3.428c-0.26,0-0.471,0.211-0.471,0.471v4.473c0,0.26,0.211,0.471,0.471,0.471h0.549 c0.259,0,0.471-0.211,0.471-0.471v-1.078h2.241c0.209,1.723,0.883,3.301,1.891,4.607l-1.576,1.576L6.25,22.588 c-0.184-0.184-0.482-0.184-0.666,0l-0.388,0.387c-0.184,0.186-0.184,0.482,0,0.666l3.163,3.162c0.184,0.186,0.481,0.186,0.666,0 l0.388-0.389c0.184-0.184,0.184-0.48,0-0.664l-0.781-0.781l1.565-1.566c1.294,1.025,2.865,1.719,4.582,1.951v2.197h-1.015 c-0.26,0-0.471,0.213-0.471,0.473v0.549c0,0.26,0.211,0.471,0.471,0.471h4.472c0.26,0,0.471-0.211,0.471-0.471v-0.549 c0-0.26-0.211-0.473-0.471-0.473H17.08v-2.17c1.789-0.195,3.426-0.889,4.771-1.941l1.523,1.523l-0.787,0.787 c-0.184,0.184-0.184,0.48,0,0.664l0.387,0.389c0.186,0.186,0.482,0.186,0.666,0l3.162-3.162c0.186-0.184,0.186-0.48,0-0.666 l-0.389-0.387c-0.184-0.184-0.48-0.184-0.664,0l-0.748,0.746l-1.523-1.521c1.029-1.316,1.715-2.91,1.928-4.654h2.145v1.078 c0,0.26,0.213,0.471,0.473,0.471h0.549c0.26,0,0.471-0.211,0.471-0.471v-4.473C29.043,13.504,28.832,13.293,28.572,13.293z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 13.36,
    cy: 12.271,
    r: 2.06
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 19.538,
    cy: 20.215,
    r: 1.118
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovid19);
export default __webpack_public_path__ + "static/media/covid19.73b4bc328047ceff3a62db3782f9decb.svg";
export { ForwardRef as ReactComponent };